import React, { useEffect, useMemo, useRef, useState } from "react";
import "./stylepersonal.css";
import { MdPersonAddAlt } from "react-icons/md";
import { HiPaperClip } from "react-icons/hi";
import { Plus } from "lucide-react";
import { FiEdit2, FiTrash2, FiX } from "react-icons/fi";
import { IoIosPerson } from "react-icons/io";
import { GiOfficeChair } from "react-icons/gi";
import { MdContactEmergency } from "react-icons/md";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  MdAddChart,
  MdFormatListBulletedAdd,
  MdMenuOpen,
  MdAddCircleOutline,
} from "react-icons/md";
import { TbEPassport } from "react-icons/tb";
import { IoIosContact } from "react-icons/io";
import { IoDocumentsOutline, IoAddCircleSharp } from "react-icons/io5";
import { GiThreeLeaves } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import { BiSolidEditAlt } from "react-icons/bi";
import { IoTime, IoDocumentText } from "react-icons/io5";
import {
  Lock,
  LocationOn,
  Person,
  AccountCircle,
  Badge,
  Wc,
  Height as HeightIcon,
  MonitorWeight,
  Language,
  VpnKey,
  AlternateEmail,
  Work,
  CheckCircle,
  CalendarToday,
  Favorite,
  GroupWork,
  Visibility,
  Accessibility,
  Home as HomeIcon,
  FlightTakeoff as FlightTakeoffIcon,
  LocationOn as LocationOnIcon,
  PhoneIphone as PhoneIphoneIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  AssignmentInd as PassportIcon,
  Event as EventIcon,
  LocationCity as PlaceIcon,
  Public as CountryIcon,
  InsertDriveFile as ImageIcon,
  ManageAccounts,
  Close as CloseIcon,
  Business as BusinessIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Info as InfoIcon,
  CalendarMonth as CalendarMonthIcon,
  TrendingUp as TrendingUpIcon,
  Payments as PaymentsIcon,
  ContactEmergency as ContactEmergencyIcon,
  CreditCard as CreditCardIcon,
  Person as PersonIcon,
  Engineering as EngineeringIcon,
  WorkOutline as WorkOutlineIcon,
  Apartment as ApartmentIcon,
  AccountBalance as AccountBalanceIcon,
  Category as CategoryIcon,
  StarHalf as StarHalfIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Work as WorkIcon,
  AccessTime as AccessTimeIcon,
  BadgeSharp as BadgeIcon,
} from "@mui/icons-material";
import dayjs from "dayjs";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Snackbar, Alert } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAllEmp } from "../../../features/Emp/EmpSlice";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { base_url } from "../../../utils/AxiosConfig";
import { base_url_image_post_api } from "../../../utils/ImageCreationAPI";
import MasterJobTablePopUp from "./MasterJobTablePopUp";

import CreateAllowance from "../CreateAllowance/CreateAllowance";
import CreateIncrement from "../CreateIncrement/CreateIncrement";
import SalaryPayablePopup from "./SalaryPayablePopup";
import user1 from "../../../images/ic_no_person_photo.svg";

// ─── Yup Schema (UNCHANGED) ────────────────────────────────────────────────────
let Empschema = Yup.object().shape({
  CmpCode: Yup.string(),
  EmpId: Yup.string().required("Emp Id Required"),
  AlternateID: Yup.string(),
  Status: Yup.string(),
  Title: Yup.string(),
  FistName: Yup.string().required("First Name Required"),
  MiddleName: Yup.string(),
  LastName: Yup.string().required("Last Name Required"),
  DOB: Yup.date().nullable(),
  MaritalStatus: Yup.string(),
  Gender: Yup.string(),
  Nationality: Yup.string(),
  Height: Yup.string(),
  Weight: Yup.string(),
  JoinDate: Yup.date().required("JoinDate Required"),
  JobTitle: Yup.string(),
  JobType: Yup.string(),
  ShiftGroup: Yup.string(),
  Department: Yup.string(),
  Division: Yup.string(),
  Grade: Yup.string(),
  BankAccountNo: Yup.string(),
  BankName: Yup.string(),
  AgentID: Yup.string(),
  CurrentAddress: Yup.string(),
  HomeAddress: Yup.string(),
  HomeAirport: Yup.string(),
  WorkMobile: Yup.string(),
  PersonalMobile: Yup.string(),
  WorkPhone: Yup.string(),
  PersonalPhone: Yup.string(),
  WorkEmail: Yup.string(),
  PersonalEmail: Yup.string(),
  PassportNo: Yup.string(),
  PassportIssueDate: Yup.date().nullable(),
  PassportExpiryDate: Yup.date().nullable(),
  PassportPlaceofIssue: Yup.string(),
  PassportCountryofIssue: Yup.string(),
  PartTimeLabour: Yup.string().nullable(),
  PartTimeLabourExpiryDate: Yup.date().nullable(),
  EmiratesId: Yup.string(),
  EmiratesIdExpiryDate: Yup.date().nullable(),
  VisaNo: Yup.string(),
  VisaExpiryDate: Yup.date().nullable(),
  InsuranceNo: Yup.string(),
  InsuranceExpiryDate: Yup.date().nullable(),
  DrivingLicenceNo: Yup.string(),
  DrivingLicenceExpiryDate: Yup.date().nullable(),
  PersonId: Yup.string(),
  PersonIdExpiryDate: Yup.date().nullable(),
  BasicPay: Yup.number(),
  Allowances_OT: Yup.number(),
  Allowances_NOT: Yup.number(),
  NetSalary: Yup.number(),
  NormalHrs: Yup.number(),
  HourlyWage: Yup.number(),
  OTrate: Yup.number(),
  SplOtRate: Yup.number(),
  photo: Yup.string(),
  Active: Yup.string(),
  Memos: Yup.string(),
  Notes: Yup.string(),
  SalaryAc: Yup.string(),
  AdvanceAc: Yup.string(),
  password: Yup.string(),
  onlineallow: Yup.string(),
});

// ─── Tailwind UI Primitives ────────────────────────────────────────────────────

/** Reusable labeled text input */
const TInput = ({
  label,
  icon,
  error,
  helperText,
  className = "",
  ...props
}) => (
  <div className={`flex flex-col gap-1 ${className}`}>
    {label && (
      <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
        {label}
      </label>
    )}
    <div className="relative">
      {icon && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 flex items-center">
          {icon}
        </span>
      )}
      <input
        className={`w-full ${icon ? "pl-9" : "pl-3"} pr-3 py-2.5 rounded-xl border text-sm text-slate-900 bg-white
          placeholder:text-slate-400 transition-all duration-200 outline-none
          ${error
            ? "border-red-400 focus:ring-2 focus:ring-red-300 focus:border-red-400"
            : "border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          }`}
        {...props}
      />
    </div>
    {helperText && <p className="text-xs text-red-500 mt-0.5">{helperText}</p>}
  </div>
);

/** Reusable labeled select */
const TSelect = ({
  label,
  icon,
  error,
  helperText,
  children,
  className = "",
  ...props
}) => (
  <div className={`flex flex-col gap-1 ${className}`}>
    {label && (
      <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
        {label}
      </label>
    )}
    <div className="relative">
      {icon && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 z-10 flex items-center">
          {icon}
        </span>
      )}
      <select
        className={`w-full ${icon ? "pl-9" : "pl-3"} pr-8 py-2.5 rounded-xl border text-sm text-slate-900 bg-white
          appearance-none cursor-pointer transition-all duration-200 outline-none
          ${error
            ? "border-red-400 focus:ring-2 focus:ring-red-300"
            : "border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          }`}
        {...props}
      >
        {children}
      </select>
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </span>
    </div>
    {helperText && <p className="text-xs text-red-500 mt-0.5">{helperText}</p>}
  </div>
);

/** Accordion / collapsible section card */
const Section = ({ title, icon, children, defaultOpen = true }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div
      className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden"
      style={{ contentVisibility: open ? "visible" : "auto" }}
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-5 py-4 hover:bg-slate-50 transition-colors duration-150"
      >
        <div className="flex items-center gap-3">
          <span className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600 flex-shrink-0">
            {icon}
          </span>
          <span className="text-sm font-bold text-slate-700 uppercase tracking-wide">
            {title}
          </span>
        </div>
        <svg
          className={`w-5 h-5 text-slate-400 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {open && (
        <div className="px-5 pb-6 border-t border-slate-100 pt-4">
          {children}
        </div>
      )}
    </div>
  );
};

/** Toggle switch replacement for MUI Switch */
const TToggle = ({ checked, onChange, label }) => (
  <label className="flex items-center gap-3 cursor-pointer select-none">
    <div
      onClick={() => onChange(!checked)}
      className={`relative w-11 h-6 rounded-full transition-colors duration-200 ${checked ? "bg-blue-600" : "bg-slate-300"}`}
    >
      <span
        className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform duration-200 ${checked ? "translate-x-5" : "translate-x-0"}`}
      />
    </div>
    {label && (
      <span className="text-sm font-medium text-slate-700">{label}</span>
    )}
  </label>
);

/** Inline master-list row (add/edit/delete for dept, division, etc.) */
const MasterRow = ({ item, onEdit, onDelete }) => (
  <div className="flex items-center justify-between px-3 py-2 rounded-xl hover:bg-slate-50 border border-transparent hover:border-slate-200 transition-all group">
    <span className="text-sm text-slate-700 font-medium">
      {item.Description}
    </span>
    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
      <button
        type="button"
        onClick={() => onEdit(item)}
        className="w-7 h-7 flex items-center justify-center rounded-lg text-blue-500 hover:bg-blue-50 transition-colors"
      >
        <FiEdit2 className="w-3.5 h-3.5" />
      </button>
      <button
        type="button"
        onClick={() => onDelete(item)}
        className="w-7 h-7 flex items-center justify-center rounded-lg text-red-400 hover:bg-red-50 transition-colors"
      >
        <FiTrash2 className="w-3.5 h-3.5" />
      </button>
    </div>
  </div>
);

/** Badge component */
const StatusBadge = ({ label, color = "blue" }) => {
  const colors = {
    blue: "bg-blue-50 text-blue-700 border-blue-200",
    green: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    red: "bg-red-50 text-red-700 border-red-200",
    slate: "bg-slate-100 text-slate-600 border-slate-200",
  };
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-lg text-xs font-semibold border ${colors[color] || colors.blue}`}
    >
      {label}
    </span>
  );
};

// ─── Main Component ────────────────────────────────────────────────────────────
const PersonalInfo = () => {
  // ── Initial states (UNCHANGED) ───────────────────────────────────────────────
  const initialBranchInAction = {
    branch_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374",
    mode: "ENTRY",
  };
  const initialDivisionInAction = {
    division_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7375",
    mode: "ENTRY",
  };
  const initialJobTitleInAction = {
    jobTitle_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7376",
    mode: "ENTRY",
  };
  const initialGradeInAction = {
    grade_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374",
    mode: "ENTRY",
  };
  const initialStatusInAction = {
    status_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7378",
    mode: "ENTRY",
  };
  const initialShiftGroupInAction = {
    shiftGroup_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7377",
    mode: "ENTRY",
  };

  const initialBranchInActionEdit = {
    branch_name: "",
    transaction_id: "",
    mode: "EDIT",
  };
  const initialDivisionInActionEdit = {
    division_name: "",
    transaction_id: "",
    mode: "EDIT",
  };
  const initialJobTitleInActionEdit = {
    jobTitle_name: "",
    transaction_id: "",
    mode: "EDIT",
  };
  const initialStatusInActionEdit = {
    status_name: "",
    transaction_id: "",
    mode: "EDIT",
  };
  const initialGradeInActionEdit = {
    grade_name: "",
    transaction_id: "",
    mode: "EDIT",
  };
  const initialShiftGroupInActionEdit = {
    shiftGroup_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  // ── State (UNCHANGED) ────────────────────────────────────────────────────────
  const [branchNameInInputBoxNew, setBranchNameInInputBoxNew] = useState(
    initialBranchInAction,
  );
  const [divisionNameInInputBoxNew, setDivisionNameInInputBoxNew] = useState(
    initialDivisionInAction,
  );
  const [jobTitleNameInInputBoxNew, setJobTitleNameInInputBoxNew] = useState(
    initialJobTitleInAction,
  );
  const [gradeNameInInputBoxNew, setGradeNameInInputBoxNew] =
    useState(initialGradeInAction);
  const [statusNameInInputBoxNew, setStatusNameInInputBoxNew] = useState(
    initialStatusInAction,
  );
  const [shiftGroupNameInInputBoxNew, setShiftGroupNameInInputBoxNew] =
    useState(initialShiftGroupInAction);
  const [branchNameInInputBoxEdit, setBranchNameInInputBoxEdit] = useState(
    initialBranchInActionEdit,
  );
  const [gradeNameInInputBoxEdit, setGradeNameInInputBoxEdit] = useState(
    initialGradeInActionEdit,
  );
  const [divisionNameInInputBoxEdit, setDivisionNameInInputBoxEdit] = useState(
    initialDivisionInActionEdit,
  );
  const [jobTitleNameInInputBoxEdit, setJobTitleNameInInputBoxEdit] = useState(
    initialJobTitleInActionEdit,
  );
  const [statusNameInInputBoxEdit, setStatusNameInInputBoxEdit] = useState(
    initialStatusInActionEdit,
  );
  const [shiftGroupNameInInputBoxEdit, setShiftGroupNameInInputBoxEdit] =
    useState(initialShiftGroupInActionEdit);

  const [showDepartmentCreationEditPopup, setShowDepartmentCreationEditPopup] =
    useState(false);
  const [showGradeCreationEditPopup, setShowGradeCreationEditPopup] =
    useState(false);
  const [showDivisionCreationEditPopup, setShowDivisionCreationEditPopup] =
    useState(false);
  const [showJobTitleCreationEditPopup, setShowJobTitleCreationEditPopup] =
    useState(false);
  const [showStatusCreationEditPopup, setShowStatusCreationEditPopup] =
    useState(false);
  const [showShiftGroupCreationEditPopup, setShowShiftGroupCreationEditPopup] =
    useState(false);

  const [departmentLisFromAPI, setDepartmentLisFromAPI] = useState(null);
  const [divisionListFromAPI, setDivisionListFromAPI] = useState(null);
  const [gradeListFromAPI, setGradeListFromAPI] = useState(null);
  const [shiftGroupListFromAPI, setShiftGroupListFromAPI] = useState(null);
  const [jobTitleListFromAPI, setJobTitleListFromAPI] = useState(null);
  const [statusListFromAPI, setStatusListFromAPI] = useState(null);

  let initialDOBDate = format(new Date(), "yyyy-MM-dd");
  let initialJoiningDate = format(new Date(), "yyyy-MM-dd");

  let portNumberLocal = localStorage.getItem("BondTimeportNoData");
  let portNumber = JSON.parse(portNumberLocal)[0].PORTNO;

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = storedUserDataArray?.[0]?.cmpcode || null;

  const [Category, setCategory] = useState(true);
  const [valuedata, setValuedata] = useState(null);
  const [EmpId, setEmpId] = useState(false);
  const [EmpIdTop, setEmpIdTop] = useState(null);
  const [DupCheck, setDupCheck] = useState(false);
  const [basicPay, setbasicPay] = useState();
  const [allowanceAmountSum, setAllowanceAmountSum] = useState(0);
  const [incrementAmountSum, setIncrementAmountSum] = useState(0);
  const [AllowanceData, setAllowanceData] = useState(null);
  const [IncrementData, setIncrementData] = useState(null);
  const [IncTotal, setIncTotal] = useState(null);
  const [AlvTotal, setAlvTotal] = useState(null);
  const [SalaryPayment, setSalaryPay] = useState();
  const [showSubmitLoader, setShowSubmitLoader] = useState(false);
  const [userDataArray, setUserDataArray] = useState([]);
  const [loginUser, setLoginUser] = useState("");
  const [imagePath, setImagePath] = useState("");
  const [imageDescription, setImageDescription] = useState("EMPIMAGE");
  const [photo, setPhoto] = useState(null);
  const [photoFile, setPhototFile] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [leaveHistoryData, setLeaveHistoryData] = useState();
  const [leaveStatusData, setLeaveStatusData] = useState();

  const empState = useSelector((state) => state?.emp?.emplist);
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const handleCloseSnackbar = () =>
    setSnackbar((prev) => ({ ...prev, open: false }));

  // ── Helpers (UNCHANGED) ──────────────────────────────────────────────────────
  const getDefaultDateTime = () => {
    const now = new Date();
    now.setHours(8, 0, 0, 0);
    const pad = (n) => n.toString().padStart(2, "0");
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:00`;
  };

  const formatDateTimeSQL = (value) => {
    const date = new Date(value);
    const pad = (n) => n.toString().padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  };

  const calculateAge = (dob) => {
    if (!dob) return "";
    return dayjs().diff(dayjs(dob), "year");
  };

  // ── Formik (FIXED: stable deps to prevent field reset) ──────────────────────
  const formikInitialValues = useMemo(() => ({
    CmpCode: companyCode,
    mode: "ENTRY",
    EmpId: "",
    AlternateID: "",
    Status: "",
    Title: "",
    FistName: "",
    MiddleName: "",
    LastName: "",
    DOB: initialDOBDate,
    MaritalStatus: "",
    Gender: "",
    Nationality: "",
    Height: "",
    Weight: "",
    JoinDate: initialJoiningDate,
    JobTitle: "",
    JobType: "",
    ShiftGroup: "",
    Department: "",
    Division: "",
    Grade: "",
    BankAccountNo: "",
    BankName: "",
    AgentID: "",
    CurrentAddress: "",
    HomeAddress: "",
    HomeAirport: "",
    WorkMobile: "",
    PersonalMobile: "",
    WorkPhone: "",
    PersonalPhone: "",
    WorkEmail: "",
    PersonalEmail: "",
    PassportNo: "",
    PassportIssueDate: null,
    PassportExpiryDate: null,
    PassportPlaceofIssue: "",
    PassportCountryofIssue: "",
    EmiratesId: "",
    EmiratesIdExpiryDate: null,
    VisaNo: "",
    VisaExpiryDate: null,
    InsuranceNo: "",
    InsuranceExpiryDate: null,
    DrivingLicenceNo: "",
    DrivingLicenceExpiryDate: null,
    PersonId: "",
    PersonIdExpiryDate: null,
    BasicPay: 0,
    Allowances_OT: 0,
    Allowances_NOT: 0,
    NetSalary: 0,
    NormalHrs: 0,
    HourlyWage: 0,
    OTrate: 0,
    SplOtRate: 0,
    photo: "",
    Active: "Yes",
    Memos: "",
    Notes: "",
    SalaryAc: "",
    AdvanceAc: "",
    password: "",
    onlineallow: "T",
    Latitude: "",
    longitude: "",
    PartTimeLabour: null,
    PartTimeLabourExpiryDate: null,
    regularTime: getDefaultDateTime(),
  }), [companyCode, initialDOBDate, initialJoiningDate]);

  const formik = useFormik({
    enableReinitialize: false,
    validateOnSubmit: false,
    initialValues: formikInitialValues,
    validationSchema: Empschema,
    onSubmit: async (values) => {
      setValuedata([values]);
      try {
        const response = await axios.get(
          `${base_url}/api/DupCheck/${companyCode}/EMPCODE/${values.EmpId || null}`,
        );
        const countValue = response.data[0].COUNT;
        if (countValue === 1) {
          setSnackbar({ open: true, message: "EmpId Exist, Try With New Id", severity: "error" });
          setShowSubmitLoader(false); // ⬅️ ADD THIS
        } else {
          await postEmpData();
        }
      } catch (error) {
        console.error("DupCheckError:", error);
        setSnackbar({ open: true, message: "Error checking duplicate EmpId", severity: "error" });
        setShowSubmitLoader(false); // ⬅️ ADD THIS
      }
    },
  });

  // ── API & Handlers (UNCHANGED) ───────────────────────────────────────────────
  const handlePhotoUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setPhoto(URL.createObjectURL(file));
      setPhototFile(file);
    } else {
      alert("Please upload a valid image file!");
    }
  };


  const handleFormSubmit = async (event) => {
    event.preventDefault();

    await formik.setTouched({
      EmpId: true,
      FistName: true,
      LastName: true,
      JoinDate: true,
    });

    const errors = await formik.validateForm();
    console.log("ALL FORMIK ERRORS:", errors); // 👈 add this temporarily

    const requiredFields = ["EmpId", "FistName", "LastName", "JoinDate"];
    const relevantErrors = Object.keys(errors).filter((k) =>
      requiredFields.includes(k),
    );

    if (relevantErrors.length > 0) {
      setSnackbar({ open: true, message: "Please correct the errors in the form.", severity: "error" });
      return;
    }

    formik.submitForm();
  };



  // const handleFormSubmit = async (event) => {
  //   event.preventDefault();

  //   await formik.setTouched({
  //     EmpId: true,
  //     FistName: true,
  //     LastName: true,
  //     JoinDate: true,
  //   });

  //   const errors = await formik.validateForm();
  //   const requiredFields = ["EmpId", "FistName", "LastName", "JoinDate"];
  //   const relevantErrors = Object.keys(errors).filter((k) =>
  //     requiredFields.includes(k),
  //   );

  //   if (relevantErrors.length > 0) {
  //     setSnackbar({
  //       open: true,
  //       message: "Please correct the errors in the form.",
  //       severity: "error",
  //     });
  //     return;
  //   }

  //   // Bypass Formik's full-schema gate — call onSubmit logic directly
  //   await formik.onSubmit(formik.values, {
  //     setTouched: formik.setTouched,
  //     setErrors: formik.setErrors,
  //     setSubmitting: formik.setSubmitting,
  //   });
  // };


  const postEmpData = async () => {
    console.log("Saving Employee... inseide postEmpData");
    // setShowSubmitLoader(true);
    try {
      // const sanitizeDate = (d) => (d === "1900-01-01T00:00:00" ? "" : d);
      const sanitizeDate = (d) => {
        if (!d) return null;
        if (d === "1900-01-01T00:00:00") return null;
        if (d === "1900-01-01") return null;
        return d;
      };

      const payload = [
        {
          ...formik.values,
          CmpCode: formik.values.CmpCode?.toUpperCase(),
          DOB: sanitizeDate(formik.values.DOB),
          DrivingLicenceExpiryDate: sanitizeDate(
            formik.values.DrivingLicenceExpiryDate,
          ),
          EmiratesIdExpiryDate: sanitizeDate(
            formik.values.EmiratesIdExpiryDate,
          ),
          InsuranceExpiryDate: sanitizeDate(formik.values.InsuranceExpiryDate),
          PassportExpiryDate: sanitizeDate(formik.values.PassportExpiryDate),
          PassportIssueDate: sanitizeDate(formik.values.PassportIssueDate),
          PersonIdExpiryDate: sanitizeDate(formik.values.PersonIdExpiryDate),
          VisaExpiryDate: sanitizeDate(formik.values.VisaExpiryDate),
          regularTime: formatDateTimeSQL(formik.values.regularTime),
        },
      ];
      const EmpRes = await axios.post(
        `${base_url}/api/PersonalInfoReg/`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      if (EmpRes.data.result === "Saved") {
        await Promise.all([
          allowanceDataFromChild
            ? createAllowance(allowanceDataFromChild)
            : Promise.resolve(),
          incrementsDataFromChild
            ? createIncrement(incrementsDataFromChild)
            : Promise.resolve(),
        ]);
        setSnackbar({ open: true, message: "Emp Registered Successfully", severity: "success" });
        setIsSubmitted(true);
        setEmpIdTop(null);
        setDupCheck(false);
        setShowSubmitLoader(false);
      } else {
        setSnackbar({ open: true, message: "Something went wrong", severity: "error" });
        setShowSubmitLoader(false);
      }
      if (photoFile) {
        await sendUserImage();
      }
    } catch (error) {
      setSnackbar({ open: true, message: "An error occurred while submitting the form", severity: "error" });
      setShowSubmitLoader(false);
      setDupCheck(false);
    }
  };


  const createAllowance = async (values) => {
    try {
      const response = await axios.post(
        `${base_url}/api/PersonalInfoAllowanceReg`,
        values,
      );

      if (response.data) {
        // Show success snackbar
        // setOpenSnackbar(true);
        setSnackbar({ open: true, message: "Allowance Saved", severity: "success" });

        // if (getAllowanceList) {
        //   getAllowanceList(empState?.EmpId);
        // }
        return response.data;
      }
    } catch (error) {
      console.error("Error creating allowance:", error);
      setSnackbar({ open: true, message: "Allowance Saving failed!", severity: "error" });
      // setErrorMessage(
      //   error.response?.data?.message || "Failed to create allowance",
      // );
      // setOpenErrorSnackbar(true);
    }
  };


  const createIncrement = async (values) => {
    try {
      const response = await axios.post(
        `${base_url}/api/PersonalInfoIncrementReg`,
        values,
      );

      if (response.data) {
        // Show success snackbar
        setSnackbar({ open: true, message: "Increment Saved", severity: "success" });

        return response.data;
      }
    } catch (error) {
      console.error("Error creating increment:", error);
      setSnackbar({ open: true, message: "Increment Saving failed!", severity: "error" });
      // setErrorMessage(
      // error.response?.data?.message || "Failed to create increment",
      // );
      // setOpenErrorSnackbar(true);
    }
  };

  const dupeCheckApi = async (empId) => {
    await axios
      .get(`${base_url}/api/DupCheck/${companyCode}/EMPCODE/${empId}`)
      .then((response) => {
        const countValue = response.data[0].COUNT;
        if (countValue === 1) {
          setSnackbar({ open: true, message: "EmpId Exist Try With New Id", severity: "error" });
        }
        if (countValue === 0) {
          setEmpId(true);
          setDupCheck(true);
        }
      })
      .catch((error) => {
        console.error("DupCheckError:", error);
      });
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const sendUserImage = async () => {
    if (!photo && !photoFile) {
      setSnackbar({ open: true, message: "no picture selected", severity: "warning" });
      return;
    }
    if (!EmpIdTop) {
      setSnackbar({ open: true, message: "EmpId Required", severity: "warning" });
      return;
    }
    if (!formik.values.FistName || !formik.values.LastName) {
      setSnackbar({ open: true, message: "First Name and Last Name are required for photo upload", severity: "warning" });
      return;
    }
    try {
      const formData = new FormData();
      let resultOfBAse64Conversion = await toBase64(photoFile);
      formData.append("DOC_CODE", formik.values.EmpId);
      formData.append("DOC_TYPE", "DOCIMAGE");
      formData.append("file", photoFile);
      formData.append("cmpcode", companyCode);
      formData.append("IMGBASE64", resultOfBAse64Conversion);
      let postEmpImagePath = localStorage.getItem("PostEmpImagePath");
      let basePath = postEmpImagePath.replace(/['"]+/g, "").trim();
      if (!basePath.endsWith("\\")) basePath += "\\";
      const fullPath = `${basePath}BONDTIME_EMP_IMG\\`;
      formData.append("IMAGEPATH", fullPath);
      const imageUploadUrl =
        base_url_image_post_api?.trim().toLowerCase().startsWith("https")
          ? `${base_url_image_post_api}/api/ImageControllerNew/upload`
          : `${base_url}/api/ImageControllerNew/upload`;
      const response = await axios.post(
        imageUploadUrl,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      if (response.status === 200) {
        setSnackbar({ open: true, message: "Image uploaded successfully", severity: "success" });
        setImageDescription("");
        setPhoto("");
        setPhototFile("");
      }
    } catch (error) {
      setSnackbar({ open: true, message: "Some error occured", severity: "error" });
    }
  };

  const calculationInc = (Incsum) => {
    setIncTotal(Incsum);
  };
  const calculationAlv = (Alvsum) => {
    setAlvTotal(Alvsum);
  };
  const SalaryPayable = (SalaryPay) => {
    setSalaryPay(SalaryPay);
  };
  const clickedOnOfficeCheckin = (v) => {
    formik.setFieldValue("onlineallow", v);
  };
  const clickedOnDepartment = (v) => {
    formik.setFieldValue("Department", v);
  };
  const handleAddrTypeChange = (e) => {
    setCategory(e.target.value);
  };

  // List fetch helpers (UNCHANGED)
  const getDepartmentList = async () => {
    const r = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
    );
    if (r?.data)
      setDepartmentLisFromAPI(r.data.filter((i) => i.Description !== ""));
  };
  const getDivisionList = async () => {
    const r = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DIVISION/-`,
    );
    if (r?.data)
      setDivisionListFromAPI(r.data.filter((i) => i.Description !== ""));
  };
  const getGradeList = async () => {
    const r = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`,
    );
    if (r?.data)
      setGradeListFromAPI(r.data.filter((i) => i.Description !== ""));
  };
  const getShiftGroupList = async () => {
    const r = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/SHIFTGROUP/-`,
    );
    if (r?.data)
      setShiftGroupListFromAPI(r.data.filter((i) => i.Description !== ""));
  };
  const getJobTitleList = async () => {
    const r = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/JOBTITLE/-`,
    );
    if (r?.data)
      setJobTitleListFromAPI(r.data.filter((i) => i.Description !== ""));
  };
  const getStatusList = async () => {
    const r = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/STATUS/-`,
    );
    if (r?.data)
      setStatusListFromAPI(r.data.filter((i) => i.Description !== ""));
  };

  const getAllowanceList = async (id) => {
    const r = await axios.get(
      `${base_url}/api/PersonalInfoAllowanceList/${companyCode}/${id}`,
    );
    if (r?.data) {
      const arr = r.data.filter((i) => i.Description !== "");
      setAllowanceData(arr);
      setAllowanceAmountSum(arr.reduce((a, v) => a + v.Amount, 0));
    }
  };
  const getIncrementList = async (id) => {
    const r = await axios.get(
      `${base_url}/api/PersonalInfoIncrementList/${companyCode}/${id}`,
    );
    if (r?.data) {
      const arr = r.data.filter((i) => i.Description !== "");
      setIncrementData(arr);
      setIncrementAmountSum(arr.reduce((a, v) => a + v.Amount, 0));
    }
  };

  const LeaveHistory = async (empId) => {
    try {
      const r = await axios.get(
        `${base_url}/api/CpaysCount/${companyCode}/LEAVE_HISTORY/${empId}/-`,
      );
      if (r?.data) setLeaveHistoryData(r.data);
    } catch (err) {
      console.error(err);
    }
  };
  const LeaveStatus = async (empId) => {
    const r = await axios.get(
      `${base_url}/api/CpaysCount/${companyCode}/LEAVE_STATUS/${empId}/-`,
    );
    if (r?.data) setLeaveStatusData(r.data);
  };

  const fetchImagePath = async () => {
    try {
      const r = await axios.get(
        `${base_url}/api/MasterCount/${companyCode}/IMAGEPATH/${loginUser}/EMPIMAGE`,
      );
      if (r.status === 200) setImagePath(r.data);
    } catch (err) {
      console.log("fetchImagePathErr", err);
    }
  };

  const fetchData = async () => {
    try {
      const stored =
        JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];
      setUserDataArray(stored);
      setLoginUser(stored?.[0]?.salesman_name?.trim());
    } catch (err) {
      console.error(err);
    }
  };

  // Master CRUD APIs (UNCHANGED)
  const newDepartmentAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/ENTRY/${companyCode}/DEPARTMENT/${branchNameInInputBoxNew.branch_name}/${initialBranchInAction.transaction_id}`,
      )
      .then(() => {
        getDepartmentList();
        setBranchNameInInputBoxNew(initialBranchInAction);
      })
      .catch(() => { });
  };
  const newDivisionAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/ENTRY/${companyCode}/DIVISION/${divisionNameInInputBoxNew.division_name}/${initialDivisionInAction.transaction_id}`,
      )
      .then(() => {
        getDivisionList();
        setDivisionNameInInputBoxNew(initialDivisionInAction);
      })
      .catch(() => { });
  };
  const newGradeAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/ENTRY/${companyCode}/GRADE/${gradeNameInInputBoxNew.grade_name}/ED54A276-A746-4649-B085-43CBBAEB7374`,
      )
      .then(() => {
        getGradeList();
        setGradeNameInInputBoxNew(initialGradeInAction);
      })
      .catch(() => { });
  };
  const newJobTitleAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/ENTRY/${companyCode}/JOBTITLE/${jobTitleNameInInputBoxNew.jobTitle_name}/${initialJobTitleInAction.transaction_id}`,
      )
      .then(() => {
        getJobTitleList();
        setJobTitleNameInInputBoxNew(initialJobTitleInAction);
      })
      .catch(() => { });
  };
  const newStatusAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/ENTRY/${companyCode}/STATUS/${statusNameInInputBoxNew.status_name}/${initialStatusInAction.transaction_id}`,
      )
      .then(() => {
        getStatusList();
        setStatusNameInInputBoxNew(initialStatusInAction);
      })
      .catch(() => { });
  };
  const newShiftGroupAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/ENTRY/${companyCode}/SHIFTGROUP/${shiftGroupNameInInputBoxNew.shiftGroup_name}/${initialShiftGroupInAction.transaction_id}`,
      )
      .then(() => {
        getShiftGroupList();
        setShiftGroupNameInInputBoxNew(initialShiftGroupInAction);
      })
      .catch(() => { });
  };
  const editDepartmentAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/EDIT/${companyCode}/DEPARTMENT/${branchNameInInputBoxEdit.branch_name}/${branchNameInInputBoxEdit.transaction_id}`,
      )
      .then(() => {
        getDepartmentList();
        setBranchNameInInputBoxEdit(initialBranchInActionEdit);
      })
      .catch(() => { });
  };
  const editDivisionAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/EDIT/${companyCode}/DIVISION/${divisionNameInInputBoxEdit.division_name}/${divisionNameInInputBoxEdit.transaction_id}`,
      )
      .then(() => {
        getDivisionList();
        setDivisionNameInInputBoxEdit(initialDivisionInActionEdit);
      })
      .catch(() => { });
  };
  const editJobTitleAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/EDIT/${companyCode}/JOBTITLE/${jobTitleNameInInputBoxEdit.jobTitle_name}/${jobTitleNameInInputBoxEdit.transaction_id}`,
      )
      .then(() => {
        getJobTitleList();
        setJobTitleNameInInputBoxEdit(initialJobTitleInActionEdit);
      })
      .catch(() => { });
  };
  const editStatusAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/EDIT/${companyCode}/STATUS/${statusNameInInputBoxEdit.status_name}/${statusNameInInputBoxEdit.transaction_id}`,
      )
      .then(() => {
        getStatusList();
        setStatusNameInInputBoxEdit(initialStatusInActionEdit);
      })
      .catch(() => { });
  };
  const editGradeAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/EDIT/${companyCode}/GRADE/${gradeNameInInputBoxEdit.grade_name}/${gradeNameInInputBoxEdit.transaction_id}`,
      )
      .then(() => {
        getGradeList();
        setGradeNameInInputBoxEdit(initialGradeInActionEdit);
      })
      .catch(() => { });
  };
  const deleteGradeAPI = () => {
    axios
      .post(
        `${base_url}/api/MasterReg/DELETE/${companyCode}/GRADE/${gradeNameInInputBoxEdit.grade_name}/${gradeNameInInputBoxEdit.transaction_id}`,
      )
      .then(() => {
        getGradeList();
        setGradeNameInInputBoxEdit(initialGradeInActionEdit);
      })
      .catch(() => { });
  };

  // Effects (UNCHANGED)
  useEffect(() => {
    if (EmpIdTop) {
      dupeCheckApi(EmpIdTop);
    }
  }, [EmpIdTop]);
  useEffect(() => {
    if (EmpIdTop) {
      LeaveHistory(EmpIdTop);
      LeaveStatus(EmpIdTop);
    }
  }, [EmpIdTop]);
  useEffect(() => {
    if (formik.values.EmpId) {
      getAllowanceList(formik.values.EmpId);
      getIncrementList(formik.values.EmpId);
    }
  }, [formik.values.EmpId]);

  const [isPayrollExpanded, setIsPayrollExpanded] = useState(false);
  const [isPayrollLoading, setIsPayrollLoading] = useState(false);
  const [allowanceDataFromChild, setAllowanceDataFromChild] = useState(null);
  const [incrementsDataFromChild, setIncrementsDataFromChild] = useState(null);

  useEffect(() => {
    if (!isPayrollExpanded || !formik.values.EmpId) return;

    const loadPayroll = async () => {
      setIsPayrollLoading(true);
      try {
        await Promise.all([
          getAllowanceList(formik.values.EmpId),
          getIncrementList(formik.values.EmpId),
        ]);
      } finally {
        setIsPayrollLoading(false);
      }
    };

    loadPayroll();
  }, [isPayrollExpanded, formik.values.EmpId]);
  useEffect(() => {
    if (loginUser && companyCode && portNumber) {
      fetchImagePath();
    }
  }, [loginUser, companyCode, portNumber]);
  useEffect(() => {
    fetchData();
    getDepartmentList();
    getDivisionList();
    getJobTitleList();
    getStatusList();
    getGradeList();
    getShiftGroupList();
    dispatch(getAllEmp());
  }, []);

  const handleAllowanceValuesChange = (values) => {
    // setEmp(values.EmpId);
    setAllowanceDataFromChild(values.allowances);
    // console.log("values from alowance to parent1 :", values.allowances);
  };
  const handleIncrementValuesChange = (values) => {
    setIncrementsDataFromChild(values.increments);
    // console.log("values from increments to parent1 :", values.increments);
  };

  // ── RENDER ───────────────────────────────────────────────────────────────────
  return (
    <form
      onSubmit={handleFormSubmit}
      className="h-screen overflow-y-auto bg-slate-50 p-6 space-y-6"
    >
      {/* ── Page Header ─────────────────────────────────────────────────────── */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-blue-700 flex items-center justify-center shadow-md">
            <MdPersonAddAlt className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-slate-900 tracking-tight">
              Employee Registration
            </h1>
            <p className="text-xs text-slate-500 mt-0.5">
              Fill in all required fields to register a new employee
            </p>
          </div>
        </div>

        {/* Submit button + loader */}
        <button
          type="submit"
          disabled={showSubmitLoader}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white text-sm font-semibold rounded-xl shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          {showSubmitLoader ? (
            <Oval
              height={16}
              width={16}
              color="#fff"
              secondaryColor="#bfdbfe"
              strokeWidth={3}
            />
          ) : (
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          )}
          {showSubmitLoader ? "Saving…" : "Save Employee"}
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        {/* ── LEFT COLUMN (2/3) ─────────────────────────────────────────────── */}
        <div className="lg:col-span-2 space-y-4">
          {/* Photo Upload Card */}
          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 flex items-center gap-5">
            {/* Avatar */}
            <div className="relative flex-shrink-0">
              <div className="w-20 h-20 rounded-2xl overflow-hidden border-2 border-slate-200 shadow-sm bg-slate-100">
                <img
                  src={photo || user1}
                  alt="Employee"
                  className="w-full h-full object-cover"
                />
              </div>
              <label
                htmlFor="PhotoUpload"
                className="absolute -bottom-2 -right-2 w-7 h-7 rounded-full bg-blue-600 flex items-center justify-center cursor-pointer shadow-md hover:bg-blue-700 transition-colors"
              >
                <BiSolidEditAlt className="w-3.5 h-3.5 text-white" />
              </label>
            </div>

            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-slate-700 mb-1">
                Employee Photo
              </p>
              <p className="text-xs text-slate-400 mb-3">
                Upload a JPG or PNG image (max. 5 MB).
              </p>
              <input
                id="PhotoUpload"
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handlePhotoUpload}
                className="hidden"
              />
              <label
                htmlFor="PhotoUpload"
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-xl border border-slate-300 text-xs font-semibold text-slate-600 hover:bg-slate-50 cursor-pointer transition-colors"
              >
                <HiPaperClip className="w-3.5 h-3.5" />
                Choose File
              </label>
            </div>

            <button
              type="button"
              onClick={sendUserImage}
              className="flex-shrink-0 inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold transition-all duration-200 shadow-sm"
            >
              Upload Photo
            </button>
          </div>

          {/* ── Personal Information ──────────────────────────────────────── */}
          <Section
            title="Personal Information"
            icon={<IoIosPerson className="w-4 h-4" />}
          >
            {/* Row 1: EmpId, Password, Active */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
              <TInput
                label="Employee ID *"
                icon={<Work style={{ fontSize: 16 }} />}
                name="EmpId"
                value={formik.values.EmpId}
                onChange={(e) => {
                  formik.handleChange(e);
                  setEmpIdTop(e.target.value);
                }}
                onBlur={formik.handleBlur}
                placeholder="e.g. EMP-001"
                error={formik.touched.EmpId && Boolean(formik.errors.EmpId)}
                helperText={formik.touched.EmpId && formik.errors.EmpId}
              />
              <TInput
                label="App Password"
                icon={<VpnKey style={{ fontSize: 16 }} />}
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="App login password"
              />
              <TSelect
                label="Active"
                icon={<CheckCircle style={{ fontSize: 16 }} />}
                name="Active"
                value={formik.values.Active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">— Select —</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </TSelect>
            </div>

            {/* Row 2: Status, AlternateID */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
              <TSelect
                label="Status"
                icon={<InfoIcon style={{ fontSize: 16 }} />}
                name="Status"
                value={formik.values.Status}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">— Select Status —</option>
                {statusListFromAPI?.map((s) => (
                  <option key={s.TransactionID} value={s.Description}>
                    {s.Description}
                  </option>
                ))}
              </TSelect>
              <TInput
                label="Alternate ID"
                icon={<AlternateEmail style={{ fontSize: 16 }} />}
                name="AlternateID"
                value={formik.values.AlternateID}
                onChange={formik.handleChange}
                placeholder="Alternate identifier"
              />
              <TSelect
                label="Title"
                name="Title"
                value={formik.values.Title}
                onChange={formik.handleChange}
              >
                <option value="">— Title —</option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Ms">Ms</option>
                <option value="Dr">Dr</option>
              </TSelect>
            </div>

            {/* Row 3: First, Middle, Last Name */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
              <TInput
                label="First Name *"
                icon={<AccountCircle style={{ fontSize: 16 }} />}
                name="FistName"
                value={formik.values.FistName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="First name"
                error={
                  formik.touched.FistName && Boolean(formik.errors.FistName)
                }
                helperText={formik.touched.FistName && formik.errors.FistName}
              />
              <TInput
                label="Middle Name"
                name="MiddleName"
                value={formik.values.MiddleName}
                onChange={formik.handleChange}
                placeholder="Middle name"
              />
              <TInput
                label="Last Name *"
                name="LastName"
                value={formik.values.LastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Last name"
                error={
                  formik.touched.LastName && Boolean(formik.errors.LastName)
                }
                helperText={formik.touched.LastName && formik.errors.LastName}
              />
            </div>

            {/* Row 4: DOB, Gender, Nationality */}
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-5">
              <TInput
                label="Date of Birth"
                type="date"
                icon={<CalendarToday style={{ fontSize: 16 }} />}
                name="DOB"
                value={formik.values.DOB}
                onChange={formik.handleChange}
              />
              {/* Age (derived) */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  Age
                </label>
                <div className="px-3 py-2.5 rounded-xl border border-slate-200 bg-slate-50 text-sm text-slate-600 font-semibold">
                  {calculateAge(formik.values.DOB) || "—"} yrs
                </div>
              </div>
              <TSelect
                label="Gender"
                icon={<Wc style={{ fontSize: 16 }} />}
                name="Gender"
                value={formik.values.Gender}
                onChange={formik.handleChange}
              >
                <option value="">— Select —</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </TSelect>
              <TInput
                label="Nationality"
                icon={<Language style={{ fontSize: 16 }} />}
                name="Nationality"
                value={formik.values.Nationality}
                onChange={formik.handleChange}
                placeholder="e.g. Indian"
              />
            </div>

            {/* Row 5: Height, Weight, Marital */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <TInput
                label="Height (cm)"
                icon={<HeightIcon style={{ fontSize: 16 }} />}
                name="Height"
                value={formik.values.Height}
                onChange={formik.handleChange}
                placeholder="e.g. 175"
              />
              <TInput
                label="Weight (kg)"
                icon={<MonitorWeight style={{ fontSize: 16 }} />}
                name="Weight"
                value={formik.values.Weight}
                onChange={formik.handleChange}
                placeholder="e.g. 70"
              />
              <TSelect
                label="Marital Status"
                icon={<Favorite style={{ fontSize: 16 }} />}
                name="MaritalStatus"
                value={formik.values.MaritalStatus}
                onChange={formik.handleChange}
              >
                <option value="">— Select —</option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Divorced">Divorced</option>
                <option value="Widowed">Widowed</option>
              </TSelect>
            </div>
          </Section>

          {/* ── Job Information ───────────────────────────────────────────── */}
          <Section
            title="Job Information"
            icon={<GiOfficeChair className="w-4 h-4" />}
          >
            {/* Join Date, Job Type, Shift Group */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
              <TInput
                label="Join Date *"
                type="date"
                icon={<CalendarToday style={{ fontSize: 16 }} />}
                name="JoinDate"
                value={formik.values.JoinDate}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.JoinDate && Boolean(formik.errors.JoinDate)
                }
                helperText={formik.touched.JoinDate && formik.errors.JoinDate}
              />
              <TSelect
                label="Job Type"
                icon={<WorkOutlineIcon style={{ fontSize: 16 }} />}
                name="JobType"
                value={formik.values.JobType}
                onChange={formik.handleChange}
              >
                <option value="">— Select —</option>
                <option value="FullTime">Full Time</option>
                <option value="PartTime">Part Time</option>
                <option value="Contract">Contract</option>
              </TSelect>
              <TInput
                label="Regular Time"
                type="datetime-local"
                icon={<AccessTimeIcon style={{ fontSize: 16 }} />}
                name="regularTime"
                value={formik.values.regularTime}
                onChange={formik.handleChange}
              />
            </div>

            {/* Department */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
              <div>
                <TSelect
                  label="Department"
                  icon={<ApartmentIcon style={{ fontSize: 16 }} />}
                  name="Department"
                  value={formik.values.Department}
                  onChange={formik.handleChange}
                >
                  <option value="">— Select Department —</option>
                  {departmentLisFromAPI?.map((d) => (
                    <option key={d.TransactionID} value={d.Description}>
                      {d.Description}
                    </option>
                  ))}
                </TSelect>
                {/* Inline add new department */}
                <div className="mt-2 flex gap-2">
                  <input
                    type="text"
                    placeholder="New department…"
                    value={branchNameInInputBoxNew.branch_name}
                    onChange={(e) =>
                      setBranchNameInInputBoxNew({
                        ...branchNameInInputBoxNew,
                        branch_name: e.target.value,
                      })
                    }
                    className="flex-1 px-3 py-1.5 text-xs rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <button
                    type="button"
                    onClick={newDepartmentAPI}
                    className="px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold transition-colors"
                  >
                    <Plus className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>

              <div>
                <TSelect
                  label="Division"
                  icon={<GroupWork style={{ fontSize: 16 }} />}
                  name="Division"
                  value={formik.values.Division}
                  onChange={formik.handleChange}
                >
                  <option value="">— Select Division —</option>
                  {divisionListFromAPI?.map((d) => (
                    <option key={d.TransactionID} value={d.Description}>
                      {d.Description}
                    </option>
                  ))}
                </TSelect>
                <div className="mt-2 flex gap-2">
                  <input
                    type="text"
                    placeholder="New division…"
                    value={divisionNameInInputBoxNew.division_name}
                    onChange={(e) =>
                      setDivisionNameInInputBoxNew({
                        ...divisionNameInInputBoxNew,
                        division_name: e.target.value,
                      })
                    }
                    className="flex-1 px-3 py-1.5 text-xs rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <button
                    type="button"
                    onClick={newDivisionAPI}
                    className="px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold transition-colors"
                  >
                    <Plus className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
              <div>
                <TSelect
                  label="Job Title"
                  icon={<BadgeIcon style={{ fontSize: 16 }} />}
                  name="JobTitle"
                  value={formik.values.JobTitle}
                  onChange={formik.handleChange}
                >
                  <option value="">— Select Job Title —</option>
                  {jobTitleListFromAPI?.map((j) => (
                    <option key={j.TransactionID} value={j.Description}>
                      {j.Description}
                    </option>
                  ))}
                </TSelect>
                <div className="mt-2 flex gap-2">
                  <input
                    type="text"
                    placeholder="New job title…"
                    value={jobTitleNameInInputBoxNew.jobTitle_name}
                    onChange={(e) =>
                      setJobTitleNameInInputBoxNew({
                        ...jobTitleNameInInputBoxNew,
                        jobTitle_name: e.target.value,
                      })
                    }
                    className="flex-1 px-3 py-1.5 text-xs rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <button
                    type="button"
                    onClick={newJobTitleAPI}
                    className="px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold transition-colors"
                  >
                    <Plus className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>

              <div>
                <TSelect
                  label="Grade"
                  icon={<StarHalfIcon style={{ fontSize: 16 }} />}
                  name="Grade"
                  value={formik.values.Grade}
                  onChange={formik.handleChange}
                >
                  <option value="">— Select Grade —</option>
                  {gradeListFromAPI?.map((g) => (
                    <option key={g.TransactionID} value={g.Description}>
                      {g.Description}
                    </option>
                  ))}
                </TSelect>
                <div className="mt-2 flex gap-2">
                  <input
                    type="text"
                    placeholder="New grade…"
                    value={gradeNameInInputBoxNew.grade_name}
                    onChange={(e) =>
                      setGradeNameInInputBoxNew({
                        ...gradeNameInInputBoxNew,
                        grade_name: e.target.value,
                      })
                    }
                    className="flex-1 px-3 py-1.5 text-xs rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <button
                    type="button"
                    onClick={newGradeAPI}
                    className="px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold transition-colors"
                  >
                    <Plus className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>

              <div>
                <TSelect
                  label="Shift Group"
                  icon={<AccessTimeIcon style={{ fontSize: 16 }} />}
                  name="ShiftGroup"
                  value={formik.values.ShiftGroup}
                  onChange={formik.handleChange}
                >
                  <option value="">— Select Shift Group —</option>
                  {shiftGroupListFromAPI?.map((s) => (
                    <option key={s.TransactionID} value={s.Description}>
                      {s.Description}
                    </option>
                  ))}
                </TSelect>
                <div className="mt-2 flex gap-2">
                  <input
                    type="text"
                    placeholder="New shift group…"
                    value={shiftGroupNameInInputBoxNew.shiftGroup_name}
                    onChange={(e) =>
                      setShiftGroupNameInInputBoxNew({
                        ...shiftGroupNameInInputBoxNew,
                        shiftGroup_name: e.target.value,
                      })
                    }
                    className="flex-1 px-3 py-1.5 text-xs rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <button
                    type="button"
                    onClick={newShiftGroupAPI}
                    className="px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold transition-colors"
                  >
                    <Plus className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            </div>

            {/* Agent ID + Office Check-in toggle */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <TInput
                label="Agent ID"
                icon={<PersonIcon style={{ fontSize: 16 }} />}
                name="AgentID"
                value={formik.values.AgentID}
                onChange={formik.handleChange}
                placeholder="Agent ID"
              />
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  Office Check-in Mandatory
                </label>
                <div className="flex items-center gap-3 mt-2">
                  <TToggle
                    checked={formik.values.onlineallow === "T"}
                    onChange={(v) => clickedOnOfficeCheckin(v ? "T" : "F")}
                  />
                  <span className="text-sm font-medium text-slate-600">
                    {formik.values.onlineallow === "T" ? "Enabled" : "Disabled"}
                  </span>
                </div>
              </div>
            </div>
          </Section>

          {/* ── Address Information ───────────────────────────────────────── */}
          <Section
            title="Address Information"
            icon={<LocationOn style={{ fontSize: 16 }} />}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  Current Address
                </label>
                <textarea
                  name="CurrentAddress"
                  rows={3}
                  value={formik.values.CurrentAddress}
                  onChange={formik.handleChange}
                  placeholder="Current residential address"
                  className="px-3 py-2.5 rounded-xl border border-slate-300 text-sm text-slate-900 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  Home Address
                </label>
                <textarea
                  name="HomeAddress"
                  rows={3}
                  value={formik.values.HomeAddress}
                  onChange={formik.handleChange}
                  placeholder="Permanent home address"
                  className="px-3 py-2.5 rounded-xl border border-slate-300 text-sm text-slate-900 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <TInput
                label="Home Airport"
                icon={<FlightTakeoffIcon style={{ fontSize: 16 }} />}
                name="HomeAirport"
                value={formik.values.HomeAirport}
                onChange={formik.handleChange}
                placeholder="e.g. DXB"
              />
              <TInput
                label="Latitude"
                icon={<LocationOnIcon style={{ fontSize: 16 }} />}
                name="Latitude"
                value={formik.values.Latitude}
                onChange={formik.handleChange}
                placeholder="GPS latitude"
              />
              <TInput
                label="Longitude"
                name="longitude"
                value={formik.values.longitude}
                onChange={formik.handleChange}
                placeholder="GPS longitude"
              />
            </div>
          </Section>

          {/* ── Contact Information ───────────────────────────────────────── */}
          <Section
            title="Contact Information"
            icon={<IoIosContact className="w-4 h-4" />}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <TInput
                label="Work Mobile"
                icon={<PhoneIphoneIcon style={{ fontSize: 16 }} />}
                name="WorkMobile"
                value={formik.values.WorkMobile}
                onChange={formik.handleChange}
                placeholder="+971 XX XXX XXXX"
              />
              <TInput
                label="Personal Mobile"
                icon={<PhoneIphoneIcon style={{ fontSize: 16 }} />}
                name="PersonalMobile"
                value={formik.values.PersonalMobile}
                onChange={formik.handleChange}
                placeholder="+971 XX XXX XXXX"
              />
              <TInput
                label="Emergency Contact & Relationship"
                icon={<ContactEmergencyIcon style={{ fontSize: 16 }} />}
                name="WorkPhone"
                value={formik.values.WorkPhone}
                onChange={formik.handleChange}
                placeholder="e.g. Jane Doe (Sister)"
              />
              <TInput
                label="Emergency Contact Number"
                icon={<PhoneIcon style={{ fontSize: 16 }} />}
                name="PersonalPhone"
                value={formik.values.PersonalPhone}
                onChange={formik.handleChange}
                placeholder="+971 XX XXX XXXX"
              />
               {/* <TInput
                label="Work Phone"
                icon={<PhoneIcon style={{ fontSize: 16 }} />}
                name="WorkPhone"
                value={formik.values.WorkPhone}
                onChange={formik.handleChange}
                placeholder="Office phone"
              />
              <TInput
                label="Personal Phone"
                icon={<PhoneIcon style={{ fontSize: 16 }} />}
                name="PersonalPhone"
                value={formik.values.PersonalPhone}
                onChange={formik.handleChange}
                placeholder="Home phone"
              /> */}
              <TInput
                label="Work Email"
                icon={<EmailIcon style={{ fontSize: 16 }} />}
                name="WorkEmail"
                type="email"
                value={formik.values.WorkEmail}
                onChange={formik.handleChange}
                placeholder="work@company.com"
              />
              <TInput
                label="Personal Email"
                icon={<EmailIcon style={{ fontSize: 16 }} />}
                name="PersonalEmail"
                type="email"
                value={formik.values.PersonalEmail}
                onChange={formik.handleChange}
                placeholder="personal@email.com"
              />
            </div>
          </Section>



          {/* Salary card was here  */}
        </div>
        {/* ── RIGHT COLUMN (1/3) ────────────────────────────────────────────── */}
        <div className="space-y-4">
          {/* ── Documents & IDs ──────────────────────────────────────────── */}
          <Section
            title="Documents & IDs"
            icon={<IoDocumentsOutline className="w-4 h-4" />}
            defaultOpen={true}
          >
            {/* Passport */}
            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3 flex items-center gap-1.5">
              <TbEPassport className="w-4 h-4 text-blue-400" /> Passport
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
              <TInput
                label="Passport No"
                name="PassportNo"
                value={formik.values.PassportNo}
                onChange={formik.handleChange}
                placeholder="A12345678"
              />
              <TInput
                label="Issue Date"
                type="date"
                name="PassportIssueDate"
                value={formik.values.PassportIssueDate}
                onChange={formik.handleChange}
              />
              <TInput
                label="Expiry Date"
                type="date"
                name="PassportExpiryDate"
                value={formik.values.PassportExpiryDate}
                onChange={formik.handleChange}
              />
              <TInput
                label="Place of Issue"
                name="PassportPlaceofIssue"
                value={formik.values.PassportPlaceofIssue}
                onChange={formik.handleChange}
                placeholder="Dubai"
              />
              <TInput
                label="Country of Issue"
                name="PassportCountryofIssue"
                value={formik.values.PassportCountryofIssue}
                onChange={formik.handleChange}
                placeholder="UAE"
              />
            </div>

            <div className="border-t border-slate-100 pt-4 mb-3">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3 flex items-center gap-1.5">
                <CreditCardIcon
                  style={{ fontSize: 14 }}
                  className="text-blue-400"
                />{" "}
                Emirates ID
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                <TInput
                  label="Emirates ID"
                  name="EmiratesId"
                  value={formik.values.EmiratesId}
                  onChange={formik.handleChange}
                  placeholder="784-XXXX-XXXXXXX-X"
                />
                <TInput
                  label="Expiry Date"
                  type="date"
                  name="EmiratesIdExpiryDate"
                  value={formik.values.EmiratesIdExpiryDate}
                  onChange={formik.handleChange}
                />
              </div>
            </div>

            <div className="border-t border-slate-100 pt-4 mb-3">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3">
                Visa
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                <TInput
                  label="Visa No"
                  name="VisaNo"
                  value={formik.values.VisaNo}
                  onChange={formik.handleChange}
                  placeholder="Visa number"
                />
                <TInput
                  label="Expiry Date"
                  type="date"
                  name="VisaExpiryDate"
                  value={formik.values.VisaExpiryDate}
                  onChange={formik.handleChange}
                />
              </div>
            </div>

            <div className="border-t border-slate-100 pt-4 mb-3">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3">
                Insurance
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                <TInput
                  label="Insurance No"
                  name="InsuranceNo"
                  value={formik.values.InsuranceNo}
                  onChange={formik.handleChange}
                />
                <TInput
                  label="Expiry Date"
                  type="date"
                  name="InsuranceExpiryDate"
                  value={formik.values.InsuranceExpiryDate}
                  onChange={formik.handleChange}
                />
              </div>
            </div>

            <div className="border-t border-slate-100 pt-4 mb-3">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3">
                Driving Licence
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                <TInput
                  label="Driving Licence No"
                  name="DrivingLicenceNo"
                  value={formik.values.DrivingLicenceNo}
                  onChange={formik.handleChange}
                />
                <TInput
                  label="Expiry Date"
                  type="date"
                  name="DrivingLicenceExpiryDate"
                  value={formik.values.DrivingLicenceExpiryDate}
                  onChange={formik.handleChange}
                />
              </div>
            </div>

            <div className="border-t border-slate-100 pt-4">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3">
                Part-Time Labour
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <TInput
                  label="Labour Card No"
                  name="PartTimeLabour"
                  value={formik.values.PartTimeLabour}
                  onChange={formik.handleChange}
                />
                <TInput
                  label="Expiry Date"
                  type="date"
                  name="PartTimeLabourExpiryDate"
                  value={formik.values.PartTimeLabourExpiryDate}
                  onChange={formik.handleChange}
                />
              </div>
            </div>
          </Section>



          {/* Leave Status Card */}
          {/* <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
            <div className="flex items-center gap-3 px-5 py-4 border-b border-slate-100">
              <span className="w-8 h-8 rounded-lg bg-amber-50 flex items-center justify-center text-amber-600 flex-shrink-0">
                <GiThreeLeaves className="w-4 h-4" />
              </span>
              <span className="text-sm font-bold text-slate-700 uppercase tracking-wide">
                Leave Status
              </span>
            </div>
            <div className="p-5">
              {leaveStatusData?.length > 0 ? (
                <div className="space-y-2">
                  {leaveStatusData.map((l, i) => (
                    <div
                      key={i}
                      className="flex items-center justify-between px-3 py-2 rounded-xl bg-slate-50 border border-slate-100"
                    >
                      <span className="text-xs font-semibold text-slate-600">
                        {l.LeaveType || l.leave_type || "Leave"}
                      </span>
                      <div className="flex gap-2">
                        <span className="text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-lg">
                          {l.Balance ?? 0} bal
                        </span>
                        <span className="text-xs font-bold text-blue-600 bg-blue-50 px-2 py-0.5 rounded-lg">
                          {l.Used ?? 0} used
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center py-6 text-center">
                  <GiThreeLeaves className="w-8 h-8 text-slate-200 mb-2" />
                  <p className="text-xs text-slate-400 font-medium">
                    No leave data available
                  </p>
                  <p className="text-xs text-slate-300">
                    Enter Employee ID to load
                  </p>
                </div>
              )}
            </div>
          </div> */}

          {/* Leave History Card */}
          {/* <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
            <div className="flex items-center gap-3 px-5 py-4 border-b border-slate-100">
              <span className="w-8 h-8 rounded-lg bg-violet-50 flex items-center justify-center text-violet-600 flex-shrink-0">
                <CalendarMonthIcon style={{ fontSize: 16 }} />
              </span>
              <span className="text-sm font-bold text-slate-700 uppercase tracking-wide">
                Leave History
              </span>
            </div>
            <div className="p-5">
              {leaveHistoryData?.length > 0 ? (
                <div className="space-y-2 max-h-52 overflow-y-auto pr-1">
                  {leaveHistoryData.map((h, i) => (
                    <div
                      key={i}
                      className="flex items-center justify-between px-3 py-2 rounded-xl bg-slate-50 border border-slate-100"
                    >
                      <div>
                        <p className="text-xs font-semibold text-slate-700">
                          {h.LeaveType || h.leave_type}
                        </p>
                        <p className="text-xs text-slate-400">
                          {h.FromDate} – {h.ToDate}
                        </p>
                      </div>
                      <StatusBadge
                        label={h.Status || "Pending"}
                        color={
                          h.Status === "Approved"
                            ? "green"
                            : h.Status === "Rejected"
                              ? "red"
                              : "amber"
                        }
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center py-6 text-center">
                  <CalendarMonthIcon
                    style={{ fontSize: 32 }}
                    className="text-slate-200 mb-2"
                  />
                  <p className="text-xs text-slate-400 font-medium">
                    No leave history
                  </p>
                </div>
              )}
            </div>
          </div> */}

          {/* Bank Details Card */}
          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
            <div className="flex items-center gap-3 px-5 py-4 border-b border-slate-100">
              <span className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600 flex-shrink-0">
                <AccountBalanceIcon style={{ fontSize: 16 }} />
              </span>
              <span className="text-sm font-bold text-slate-700 uppercase tracking-wide">
                Bank Details
              </span>
            </div>
            <div className="p-5 space-y-4">
              <TInput
                label="Bank Name"
                icon={<AccountBalanceIcon style={{ fontSize: 16 }} />}
                name="BankName"
                value={formik.values.BankName}
                onChange={formik.handleChange}
                placeholder="e.g. Emirates NBD"
              />
              <TInput
                label="Account Number"
                icon={<CreditCardIcon style={{ fontSize: 16 }} />}
                name="BankAccountNo"
                value={formik.values.BankAccountNo}
                onChange={formik.handleChange}
                placeholder="Account number"
              />
              <TInput
                label="Salary Account"
                icon={<AccountBalanceWalletIcon style={{ fontSize: 16 }} />}
                name="SalaryAc"
                value={formik.values.SalaryAc}
                onChange={formik.handleChange}
                placeholder="Salary A/C"
              />
              <TInput
                label="Advance Account"
                name="AdvanceAc"
                value={formik.values.AdvanceAc}
                onChange={formik.handleChange}
                placeholder="Advance A/C"
              />
            </div>
          </div>


          {/* Notes Card  */}
          {/* ── Notes ─────────────────────────────────────────────────────── */}
          <Section
            title="Notes & Memos"
            icon={<IoDocumentText className="w-4 h-4" />}
            defaultOpen={true}
          >
            <div className="grid grid-cols-1 gap-4">
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  Notes
                </label>
                <textarea
                  name="Notes"
                  rows={4}
                  value={formik.values.Notes}
                  onChange={formik.handleChange}
                  placeholder="Additional notes…"
                  className="px-3 py-2.5 rounded-xl border border-slate-300 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  Memos
                </label>
                <textarea
                  name="Memos"
                  rows={4}
                  value={formik.values.Memos}
                  onChange={formik.handleChange}
                  placeholder="Internal memos…"
                  className="px-3 py-2.5 rounded-xl border border-slate-300 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                />
              </div>
            </div>
          </Section>

        </div>
      </div>
      {/* Salary Card  */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden ">
        <div className="flex items-center gap-3 px-5 py-4 border-b border-slate-100">
          <span className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center text-emerald-600 flex-shrink-0">
            <AccountBalanceWalletIcon style={{ fontSize: 16 }} />
          </span>
          <span className="text-sm font-bold text-slate-700 uppercase tracking-wide">
            Salary
          </span>
        </div>
        <div className="p-5 space-y-4">
          <TInput
            label="Basic Pay"
            icon={<PaymentsIcon style={{ fontSize: 16 }} />}
            name="BasicPay"
            type="number"
            value={formik.values.BasicPay}
            onChange={(e) => {
              formik.handleChange(e);
              setbasicPay(Number(e.target.value));
            }}
            placeholder="0.00"
          />
          <TInput
            label="Normal Hours"
            icon={<AccessTimeIcon style={{ fontSize: 16 }} />}
            name="NormalHrs"
            type="number"
            value={formik.values.NormalHrs}
            onChange={formik.handleChange}
          />
          <TInput
            label="Hourly Wage"
            name="HourlyWage"
            type="number"
            value={formik.values.HourlyWage}
            onChange={formik.handleChange}
          />
          <TInput
            label="OT Rate"
            name="OTrate"
            type="number"
            value={formik.values.OTrate}
            onChange={formik.handleChange}
          />
          <TInput
            label="Special OT Rate"
            name="SplOtRate"
            type="number"
            value={formik.values.SplOtRate}
            onChange={formik.handleChange}
          />

          {/* Summary pills */}
          <div className="rounded-xl bg-slate-50 border border-slate-200 p-3 space-y-2">
            {[
              {
                label: "Allowances (OT)",
                value: AlvTotal || 0,
                color: "text-blue-700",
              },
              {
                label: "Increments (NOT)",
                value: IncTotal || 0,
                color: "text-violet-700",
              },
              {
                label: "Net Salary",
                value: (
                  Number(basicPay) +
                  Number(AlvTotal || 0) +
                  Number(IncTotal || 0)
                ).toFixed(2),
                color: "text-emerald-700",
                bold: true,
              },
            ].map(({ label, value, color, bold }) => (
              <div
                key={label}
                className="flex items-center justify-between"
              >
                <span className="text-xs text-slate-500 font-medium">
                  {label}
                </span>
                <span
                  className={`text-sm font-${bold ? "bold" : "semibold"} ${color}`}
                >
                  {value}
                </span>
              </div>
            ))}
          </div>

          {/* Allowances & Increments (accordion) */}
          <div className="pt-2">
            <button
              type="button"
              onClick={() => setIsPayrollExpanded((prev) => !prev)}
              className="flex items-center justify-between w-full px-4 py-3 bg-white hover:bg-slate-50 transition-colors rounded-xl border border-slate-200"
            >
              <p className="text-xs font-bold text-slate-500 uppercase tracking-wide">
                Allowances & Increments
              </p>
              <ExpandMoreIcon
                className={`text-slate-400 transition-transform duration-200 ${isPayrollExpanded ? "rotate-180" : ""}`}
              />
            </button>

            {isPayrollExpanded && (
              <div className="mt-3 px-1">
                {!formik.values.EmpId ? (
                  <div className="px-4 py-6 text-center text-sm text-slate-400">
                    Enter an Employee ID first to manage allowances & increments.
                  </div>
                ) : isPayrollLoading ? (
                  <div className="px-4 py-6 text-center text-sm text-slate-500">
                    Loading payroll...
                  </div>
                ) : (
                  <>
                    {/* Allowance Creation */}
                    <h2 className="flex items-center text-xs font-bold uppercase tracking-wide text-blue-600 mb-3 gap-2">
                      <PaymentsIcon style={{ fontSize: 14 }} /> ALLOWANCE CREATION
                    </h2>
                    <CreateAllowance
                      calculationAlv={calculationAlv}
                      EmpIdTop={formik.values.EmpId}
                      getAllowanceList={() =>
                        getAllowanceList(formik.values.EmpId)
                      }
                      onValuesChange={handleAllowanceValuesChange}
                    />

                    {/* Allowance List */}
                    <div className="my-4 max-h-60 overflow-auto rounded-xl border border-slate-200">
                      <table className="min-w-full">
                        <thead className="sticky top-0 bg-slate-100 text-xs uppercase tracking-wide text-slate-600">
                          <tr>
                            <th className="whitespace-nowrap px-3 py-2.5 text-left font-semibold">Sl No</th>
                            <th className="whitespace-nowrap px-3 py-2.5 text-left font-semibold">Description</th>
                            <th className="whitespace-nowrap px-3 py-2.5 text-left font-semibold">Amount</th>
                            <th className="whitespace-nowrap px-3 py-2.5 text-left font-semibold">Date</th>
                            <th className="whitespace-nowrap px-3 py-2.5 text-left font-semibold">Reason</th>
                          </tr>
                        </thead>
                        <tbody className="text-sm text-slate-600">
                          {AllowanceData?.length ? (
                            AllowanceData.map((d, i) => (
                              <tr key={d.TranId || i} className="border-t border-slate-200 hover:bg-slate-50">
                                <td className="whitespace-nowrap px-3 py-2.5">{i + 1}</td>
                                <td className="whitespace-nowrap px-3 py-2.5">{d.AllowanceType}</td>
                                <td className="whitespace-nowrap px-3 py-2.5">{d.Amount}</td>
                                <td className="whitespace-nowrap px-3 py-2.5">{dayjs(d.ADate).format("DD-MMM-YYYY")}</td>
                                <td className="px-3 py-2.5">{d.AffectOTCalc}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="px-4 py-6 text-center text-sm text-slate-500">No allowances recorded.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Increment Creation */}
                    <h2 className="flex items-center text-xs font-bold uppercase tracking-wide text-blue-600 mb-3 mt-5 gap-2">
                      <TrendingUpIcon style={{ fontSize: 14 }} /> INCREMENT CREATION
                    </h2>
                    <CreateIncrement
                      calculationInc={calculationInc}
                      EmpIdTop={formik.values.EmpId}
                      getIncrementList={() =>
                        getIncrementList(formik.values.EmpId)
                      }
                      onValuesChange={handleIncrementValuesChange}
                    />

                    {/* Increment List */}
                    <div className="my-4 max-h-60 overflow-auto rounded-xl border border-slate-200">
                      <table className="min-w-full">
                        <thead className="sticky top-0 bg-slate-100 text-xs uppercase tracking-wide text-slate-600">
                          <tr>
                            <th className="whitespace-nowrap px-3 py-2.5 text-left font-semibold">Sl No</th>
                            <th className="whitespace-nowrap px-3 py-2.5 text-left font-semibold">Description</th>
                            <th className="whitespace-nowrap px-3 py-2.5 text-left font-semibold">Amount</th>
                            <th className="whitespace-nowrap px-3 py-2.5 text-left font-semibold">Date</th>
                            <th className="whitespace-nowrap px-3 py-2.5 text-left font-semibold">Reason</th>
                          </tr>
                        </thead>
                        <tbody className="text-sm text-slate-600">
                          {IncrementData?.length ? (
                            IncrementData.map((d, i) => (
                              <tr key={d.TranId || i} className="border-t border-slate-200 hover:bg-slate-50">
                                <td className="whitespace-nowrap px-3 py-2.5">{i + 1}</td>
                                <td className="whitespace-nowrap px-3 py-2.5">{d.AllowanceType}</td>
                                <td className="whitespace-nowrap px-3 py-2.5">{d.Amount}</td>
                                <td className="whitespace-nowrap px-3 py-2.5">{dayjs(d.ADate).format("DD-MMM-YYYY")}</td>
                                <td className="px-3 py-2.5">{d.AffectOTCalc}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="px-4 py-6 text-center text-sm text-slate-500">No increments recorded.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>

        </div>
      </div>

      {/* ── Salary Payable Popup (UNCHANGED) ──────────────────────────────── */}
      {/* <SalaryPayablePopup SalaryPayable={SalaryPayable} EmpIdTop={EmpIdTop} /> */}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </form>
  );
};

export default PersonalInfo;
